import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

export type UserCheckboxItem = {
  userId: string;
  userDisplayName: string;
  userName: string;
  selected: boolean;
  disabled?: boolean;
};

export interface UserCheckboxLabelProps {
  item: UserCheckboxItem;
}

const UserCheckboxLabel: FC<UserCheckboxLabelProps> = (props: UserCheckboxLabelProps) => {
  const { item } = props;

  return (
    <Stack direction='column' gap={0.25}>
      <Typography variant='responsiveParagraphBold' color='common.black' sx={{ wordBreak: 'break-all' }}>
        {item.userDisplayName}
      </Typography>
      <Typography variant='responsiveParagraphSmall' component='div' color='grey.600'>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <span>{item.userName}</span>
        </Box>
      </Typography>
    </Stack>
  );
};

export default UserCheckboxLabel;
